import { ExpandableImage } from '@/components/expandable-image';
import { Button, Flex, Text, Title } from '@mantine/core';
import { IconCamera, IconPhotoPlus } from '@tabler/icons-react';
import { AssetType } from '../../../../../backend/src/types.generated';

interface LoadPhotosSectionProps {
	photos: string[];
	onAddPhoto: () => void;
	onDeletePhoto: (photoIndex: number) => void;
	assetType: AssetType | null | undefined;
}

/**
 * Load photos section
 */
export const LoadPhotosSection: React.FC<LoadPhotosSectionProps> = ({
	photos,
	onAddPhoto,
	onDeletePhoto,
	assetType,
}) => (
	<Flex direction="column" w="100%" gap="sm">
		<Flex px="md" align="center" justify="space-between" w="100%">
			<Title order={2}>{assetType === AssetType.Load ? 'Load' : 'Audit'} Photos</Title>
		</Flex>

		<Flex px="md" direction="column" gap="md">
			{photos.length > 0 ? (
				<Flex gap="sm" wrap="wrap">
					{photos.map((photo, i) => (
						<ExpandableImage
							id={`load-photo-${i}`}
							key={i}
							src={photo}
							onDelete={() => onDeletePhoto(i)}
						/>
					))}
				</Flex>
			) : (
				<Flex
					style={{ border: '1px dashed var(--mantine-color-gray-6)', borderRadius: '6px' }}
					w="100%"
					p="md"
					direction="column"
					c="gray"
					justify="center"
					align="center"
					gap="sm"
				>
					<IconPhotoPlus size={48} />
					<Text size="md">Add load photos</Text>
				</Flex>
			)}

			<Button
				onClick={onAddPhoto}
				fullWidth
				variant="filled"
				leftSection={<IconCamera size={16} />}
			>
				Add Photos
			</Button>
		</Flex>
	</Flex>
);
